import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommentRequest } from '../types/comment';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/v1`;

  send(request: CommentRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/support/contact`, request);
  }
}
